import { v4 as uuid }                        from 'uuid';
import { BaseStore }                         from './BaseStore';
import { asType, isResolver, withResolvers } from './_apolloUtil';
import { CONTEXTS }                          from '../constants';
import { StoreQueries }                      from '../queries';

@withResolvers
export class UIStore extends BaseStore {
	
	static storeKey      = 'ui';
	static storeTypename = 'UIStore';
	static typeDefs      = `
		type UIStore{
			guid: String
		}
	`;
	
	static state = asType( UIStore.storeTypename, {
		guid: uuid()
	} );
	
	/*
	@isResolver( 'Mutation' )
	static example( _root, argsObject, { client } ){
		
		UIStore.updateState( `some gql for state object`, draft => {
			
			// do stuff to draft
			
		}, client );
		
		// return asType( 'type', { ... } );
	}
	*/
}
